<template>
    <div class="none
                bg-yellow-50 text-yellow-500
                bg-orange-50 text-orange-500"></div>
    <!-- TW Snippet Start v2.0+ -->
    <div class="pb-1 sm:pb-3">
        <div class="max-w-4xl mx-auto px-2 sm:px-6 lg:px-8">
            <div :class="'bg-' + color + '-50'" class="p-1 rounded-lg border">
                <div class="flex items-center justify-between flex-wrap">
                    <div class="w-0 flex-1 flex items-center">

                        <p :class="'text-' + color + '-500'" class="ml-3 font-medium">
                            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            <span>
                                  <slot></slot>
                            </span>

                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "InfoBar",
    props: {
        color: {
            default: 'indigo',
        }
    }
}
</script>

<style scoped>

</style>
